export const getIPAddress = async () => {
  const publicIp = localStorage.getItem('PUBLIC_IP')
  if (publicIp) {
    return publicIp
  }

  try {
    const response = await fetch('https://api.ipify.org?format=json')
    if (!response.ok) {
      return '127.0.0.1'
    }
    const data = await response.json()
    localStorage.setItem('PUBLIC_IP', data.ip)

    return data.ip
  } catch (error) {
    console.error('Error fetching IP address:', error)
    return '127.0.0.1'
  }
}
